export const FEATHER_SHOWCASE_PATH = "/feather";
export const FEATHER_APPLICANT_PATH = "/feather/applicant-flow";
export const FEATHER_APPLICANT_CHECKPOINT_PATH = "/feather/applicant-flow/checkpoint";
export const FEATHER_VOUCHER_PATH = "/feather/voucher-flow";
export const FEATHER_ATS_PATH = "/feather/ats-integration";
export const FEATHER_DEMO_SETUP_PATH = "/feather/demo-setup";

/** A live demo run's applicant journey: the real flow, under the preview bar. */
export const FEATHER_LIVE_CHECKPOINT_PATTERN = `${FEATHER_APPLICANT_CHECKPOINT_PATH}/:token`;
export const featherLiveCheckpointPath = (token: string) =>
  `${FEATHER_APPLICANT_CHECKPOINT_PATH}/${encodeURIComponent(token)}`;

export const FEATHER_FEATURED_ACCOUNT_IDS = ["linkedin", "github"] as const;
export const FEATHER_OTHER_ACCOUNT_IDS = ["apple", "facebook", "amazon"] as const;

// The review fixture and the partner's display name live in featherReview.ts,
// which only demo code reads, so a production build carries neither.
export { FEATHER_PARTNER_NAME, FEATHER_REVIEW_FLOW } from "@/lib/featherReview";
